module.exports = __webpack_public_path__ + "img/Slide_4.1428e84a.jpg";